import { useState } from "react";
import { toast } from "sonner";
import { MapPin, Phone, Mail, Clock, Send } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { openWhatsApp } from "@/lib/whatsapp";
import { Overline } from "@/components/public/ui";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export default function Contact() {
  const [form, setForm] = useState({ nom: "", email: "", telephone: "", entreprise: "", message: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.nom || !form.message) { toast.error("Veuillez renseigner votre nom et votre message."); return; }
    setLoading(true);
    try {
      await api.post("/contact", { ...form, source: "formulaire_contact", email: form.email || null });
      toast.success("Message envoyé ! Nous vous recontacterons rapidement.");
      setForm({ nom: "", email: "", telephone: "", entreprise: "", message: "" });
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div>
      <section className="bg-gradient-to-br from-[#0F2A6B] to-[#0A1F52] relative grain">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-20 relative">
          <Overline><span className="text-[#4CB944]">Contact</span></Overline>
          <h1 className="mt-3 text-4xl sm:text-5xl font-bold text-white font-head">Parlons de votre projet</h1>
          <p className="mt-4 text-lg text-slate-300 max-w-2xl">Notre équipe est à votre écoute à Abidjan.</p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16 grid lg:grid-cols-3 gap-10">
        <div className="space-y-5">
          {[[MapPin, "Adresse", "Abidjan – Cocody Riviera 3, Côte d'Ivoire"], [Phone, "Téléphone", "+225 07 98 64 77 83"], [Mail, "Email", "info@visionlogiciels.com"], [Clock, "Horaires", "Lun–Ven : 8h00 – 18h00"]].map(([Icon, t, v]) => (
            <div key={t} className="flex items-start gap-4 p-4 rounded-xl bg-white border border-slate-200">
              <div className="w-11 h-11 rounded-xl bg-[#0F2A6B]/5 grid place-items-center shrink-0"><Icon className="w-5 h-5 text-[#0F2A6B]" /></div>
              <div><div className="text-sm font-semibold text-slate-900">{t}</div><div className="text-sm text-slate-600">{v}</div></div>
            </div>
          ))}
          <button onClick={() => openWhatsApp({ page: "contact" })} className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-[#25D366] text-white font-semibold hover:bg-[#1EBE5D]">Discuter sur WhatsApp</button>
        </div>
        <form onSubmit={submit} data-testid="contact-form" className="lg:col-span-2 p-8 rounded-2xl bg-white border border-slate-200 shadow-sm space-y-5">
          <div className="grid sm:grid-cols-2 gap-4">
            <div><label className="text-sm font-medium text-slate-700">Nom complet *</label><Input data-testid="contact-nom" value={form.nom} onChange={set("nom")} className="mt-1.5" placeholder="Votre nom" /></div>
            <div><label className="text-sm font-medium text-slate-700">Entreprise</label><Input data-testid="contact-entreprise" value={form.entreprise} onChange={set("entreprise")} className="mt-1.5" placeholder="Votre société" /></div>
            <div><label className="text-sm font-medium text-slate-700">Email</label><Input data-testid="contact-email" type="email" value={form.email} onChange={set("email")} className="mt-1.5" placeholder="email@exemple.com" /></div>
            <div><label className="text-sm font-medium text-slate-700">Téléphone</label><Input data-testid="contact-telephone" value={form.telephone} onChange={set("telephone")} className="mt-1.5" placeholder="+225 ..." /></div>
          </div>
          <div><label className="text-sm font-medium text-slate-700">Message *</label><Textarea data-testid="contact-message" value={form.message} onChange={set("message")} className="mt-1.5" rows={5} placeholder="Décrivez votre besoin…" /></div>
          <button type="submit" disabled={loading} data-testid="contact-submit" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#0F2A6B] text-white font-semibold hover:bg-[#0A1F52] disabled:opacity-60">
            <Send className="w-4 h-4" />{loading ? "Envoi…" : "Envoyer le message"}
          </button>
        </form>
      </section>
    </div>
  );
}
